(function() {
  /* Message de délai (fiche produit, panier latéral, page panier) — éléments [data-pb-shipping].
     Aligné sur le checkout Shopify (délai de traitement « le jour même ») :
     relais 2 à 4 jours ouvrés, domicile volumineux 2 à 3, domicile 3 à 5 → le plus rapide en standard = expédition + 2 jours ouvrés.
     Le script peut être inclus plusieurs fois (fiche produit, panier) : une seule initialisation. */
  if (window.__pbShipMsgInit) return;
  window.__pbShipMsgInit = true;

  var CUTOFF_H = 11;
  var DELIVERY_MIN_DAYS = 2;
  var LOADING = 'Chargement';
  var DAYS_FR = ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'];
  var MONTHS_FR = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];

  function easterDate(y) {
    var a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),month=Math.floor((h+l-7*m+114)/31),day=(h+l-7*m+114)%31+1;
    return new Date(y,month-1,day);
  }

  function getFeries(y) {
    var easter = easterDate(y);
    function addDays(d,n){var r=new Date(d);r.setDate(r.getDate()+n);return r;}
    var dates = [
      new Date(y,0,1),new Date(y,4,1),new Date(y,4,8),new Date(y,6,14),
      new Date(y,7,15),new Date(y,10,1),new Date(y,10,11),new Date(y,11,25),
      addDays(easter,1),addDays(easter,39),addDays(easter,50)
    ];
    return dates.map(function(d){
      return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
    });
  }

  function isFerie(d,feries){
    var key=d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
    return feries.indexOf(key)!==-1;
  }

  function isOuvre(d,feries){var dow=d.getDay();return dow!==0&&dow!==6&&!isFerie(d,feries);}

  function nextOuvre(d,feries,skip){
    var r=new Date(d);
    if(skip)r.setDate(r.getDate()+skip);
    while(!isOuvre(r,feries)){r.setDate(r.getDate()+1);}
    return r;
  }

  function addOuvres(d,n,feries){
    var r=new Date(d),added=0;
    while(added<n){r.setDate(r.getDate()+1);if(isOuvre(r,feries))added++;}
    return r;
  }

  function fmt(d){
    return DAYS_FR[d.getDay()]+' '+d.getDate()+' '+MONTHS_FR[d.getMonth()];
  }

  window.pbShippingMsg = function() {
    var now = new Date();
    var y = now.getFullYear();
    var feries = getFeries(y).concat(getFeries(y+1));

    if(isOuvre(now,feries) && now.getHours() < CUTOFF_H) {
      var livraison = addOuvres(now, DELIVERY_MIN_DAYS, feries);
      return 'Commandez avant 11h — expédié <strong>aujourd\'hui</strong>, livré dès le <strong>'+fmt(livraison)+'</strong>';
    }
    var expedition = nextOuvre(now, feries, 1);
    var livraison2 = addOuvres(expedition, DELIVERY_MIN_DAYS, feries);
    return 'Expédié le <strong>'+fmt(expedition)+'</strong> — livré dès le <strong>'+fmt(livraison2)+'</strong>';
  };

  function buildMsg(cart) {
    var items = (cart && cart.items) || [];
    var gcCount = items.reduce(function(acc, i){ return acc + (!i.requires_shipping ? i.quantity : 0); }, 0);
    var physCount = items.reduce(function(acc, i){ return acc + (i.requires_shipping ? i.quantity : 0); }, 0);
    var gcLabel = gcCount > 1 ? 'E-cartes cadeaux' : 'E-carte cadeau';
    var gcLine = '🎁 <strong>' + gcLabel + '</strong> — envoyée' + (gcCount > 1 ? 's' : '') + ' par email dès validation de ta commande.';

    if (gcCount > 0 && physCount === 0) return gcLine;
    if (gcCount > 0) return window.pbShippingMsg() + '<br>' + gcLine;
    return window.pbShippingMsg();
  }

  var lastCart = null;
  var busy = false;

  function paint() {
    var msg = buildMsg(lastCart);
    document.querySelectorAll('[data-pb-shipping]').forEach(function(el) {
      if (el.innerHTML !== msg) el.innerHTML = msg;
    });
  }

  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){ lastCart = cart; })
      .catch(function(){})
      .then(function(){ busy = false; paint(); });
  }

  function hasLoading() {
    var els = document.querySelectorAll('[data-pb-shipping]');
    for (var i = 0; i < els.length; i++) {
      if ((els[i].textContent || '').indexOf(LOADING) !== -1) return true;
    }
    return false;
  }

  /* Le panier se redessine parfois « sur place » (texte remplacé sans nouveau bloc) :
     on regarde simplement s'il reste un « Chargement… » après chaque changement de la page. */
  var queued = false;
  function check() {
    queued = false;
    if (!hasLoading()) return;
    paint();      /* affichage immédiat avec le dernier panier connu */
    refresh();    /* puis mise à jour avec le panier à jour (cartes cadeaux) */
  }
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(check);
  }

  function start() {
    refresh();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart-drawer:open', refresh);
})();

/* PB : articles du blog : mesure la hauteur du bloc produits fixe de la colonne de gauche,
   pour caler le bloc tags juste en dessous (voir custom-overrides.css, 02/11/2026) */
(function() {
  if (window.__pbBlogSideInit) return;
  window.__pbBlogSideInit = true;
  var done = false, tries = 0;
  function go() {
    if (done) return;
    var p = document.querySelector('#article__side-bar .side-bar__product');
    if (!p) { if (tries++ < 40) setTimeout(go, 500); return; }
    done = true;
    window.removeEventListener('scroll', go);
    var set = function() { document.documentElement.style.setProperty('--pb-prod-h', p.offsetHeight + 'px'); };
    set();
    if (window.ResizeObserver) new ResizeObserver(set).observe(p);
  }
  window.addEventListener('scroll', go, { passive: true });
  go();
})();
